export var LOADING = 'LOADING';
export var SUCCESS = 'SUCCESS';
export var WARNING = 'WARNING';
export var ERROR = 'ERROR';
export var ACTION_MESSAGE = 'ACTION_MESSAGE';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dhis2/d2-ui-app/node_modules/@dhis2/d2-ui-core/build/es/feedback-snackbar/FeedbackSnackbarTypes.js
// module id = 888
// module chunks = 0